import {Locations} from 'Components/Footprint/Interfaces/FootPrintData';

const LocationState: Locations[] = [];

export default LocationState;